import React from "react";

function UltimateParent(){
    return(
        <div className="form-content">
        <ul>
            <li>
                <label className="label-full">Ultimate Direct Parent <span>*</span></label>
                <label className="switch">
                    <i>No</i>
                    <input type="checkbox" />                    
                    <span className="slider round"><i>Yes</i></span>
                </label>
            </li>
            <li>
                <label>Ultimate Present (If Reason is No) <span>*</span></label>
                <input type="text" placeholder="Ultimate Present (If Reason is No)" />
            </li>
            {/* <li>
                <label>Ultimate Parent has LEI ?  ( If Yes& also same as DP) <span>*</span></label>
                <input type="text" placeholder="Ultimate Parent has LEI ?  ( If Yes& also same as DP)" />
            </li> */}
            <li>
                <label>Ultimate Parent Name <span>*</span></label>
                <input type="text" placeholder="Ultimate Parent Name" />
            </li>
            <li>
                <label>Start Date of Relationship <span>*</span></label>
                <input type="text" placeholder="Start date of relationship" />
            </li>            
        </ul>
        <h3 className="heading3"><span>LEGAL FORM - BRANCH</span></h3>
        <ul>
            <li>
                <label>Registration Tab (Project Office)</label>
                <input type="text" placeholder="Registration Tab (Project Office)" />
            </li>
            <li>
                <label>LEI Number (If Yes/No) <span>*</span></label>
                <input type="text" placeholder="LEI Number (If Yes/No)" />
            </li>
        </ul>
    </div>
    );
}export default UltimateParent